module.exports = __webpack_public_path__ + "static/media/backend.5c6a8368.svg";